import request from '../../../helpers/request';

const editRoomDescription = async (description, room) => {
  await request.put(
    `/RentPlace/rental_house/office`,
    {
      ...room,
      description: {
        ...room.description,
        description,
      },
    },
    'При редактировании описания произошла ошибка'
  );
};

export default editRoomDescription;
